import { privateInstance } from "../configs";

const baseUrl = "supplier/api";

export const globalSupplierApi = {
  async getGlobalSuppliers() {
    const res = await privateInstance.get(`${baseUrl}/global/`);
    return res.data;
  },
  async getGlobalSupplierProducts(params) {
    let url = `${baseUrl}/global/product/`;
    if (params) {
      url += "?";
      const p = [];
      if (params.supplier) {
        p.push(`supplier=${params.supplier}`);
      }
      url += p.join("&");
    }
    const res = await privateInstance.get(url);
    return res.data;
  }
};
